module.exports = __webpack_public_path__ + "static/media/Service3.cf79087e.svg";